var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remix-icons/line/finance/funds-line",
    clipPath: "url(#clip0_3312_17855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.30451 10.8923L5.85601 8.34075L7.97701 10.4625L10.3448 8.09475L9.00001 6.75H12.75V10.5L11.4053 9.15525L7.97701 12.5835L5.85601 10.4625L3.99976 12.318C4.84232 13.5861 6.13547 14.4866 7.61718 14.8368C9.09889 15.187 10.6583 14.9608 11.9795 14.204C13.3006 13.4473 14.2847 12.2166 14.7322 10.7613C15.1797 9.30604 15.0573 7.73505 14.3897 6.3667C13.7221 4.99835 12.5592 3.93497 11.1368 3.39206C9.71434 2.84915 8.1387 2.8673 6.72915 3.44285C5.31959 4.0184 4.18156 5.10829 3.54566 6.49167C2.90975 7.87504 2.82355 9.44843 3.30451 10.893V10.8923ZM2.15101 12.0607L2.14351 12.0532L2.14651 12.0502C1.71895 11.0903 1.49866 10.0509 1.50001 9C1.50001 4.85775 4.85776 1.5 9.00001 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9.00001 16.5C5.94751 16.5 3.32251 14.6775 2.15101 12.0607Z",
    fill: "#1F36C7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3312_17855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c162ef07c4c7c7c99507e73e94560b88.svg";
export { ForwardRef as ReactComponent };